// Action Types
export const FETCH_PITCH_WO_CARD_REQUEST = "FETCH_PITCH_WO_CARD_REQUEST";
export const FETCH_PITCH_WO_CARD_SUCCESS = "FETCH_PITCH_WO_CARD_SUCCESS";
export const FETCH_PITCH_WO_CARD_FAILURE = "FETCH_PITCH_WO_CARD_FAILURE";


// Action Creators
export const fetchPitchWoCardRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_PITCH_WO_CARD_REQUEST,
      payload: {opportunityId},
    });
  };
};
export const fetchPitchWoCardSuccess = (data) => ({
  type: FETCH_PITCH_WO_CARD_SUCCESS,
  payload: data,
});
export const fetchPitchWoCardFailure = (error) => ({
  type: FETCH_PITCH_WO_CARD_FAILURE,
  payload: error,
});
